import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { marginAttributes, paddingAttributes, sizeAttributes } from '../../system/attributes';
import { getPropsBlocker } from '../../utils';
import { spacing } from '../../system/mixins';
export var ContainerRoot = styled.div.withConfig(getPropsBlocker())(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    padding: 0 ", ";\n    ", "\n    ", "\n    ", "\n"])), spacing(2), sizeAttributes, paddingAttributes, marginAttributes);